module.exports = __webpack_public_path__ + "img/05yiyang.2c80b1e2.png";